import { UsageEventBase } from './usageEventBase';
import { FormGroup } from '@angular/forms';

export class UsageEvent extends UsageEventBase {

  constructor(model: FormGroup) { super(model); }
}
